import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { IntegrationComissao } from '../integration-comissao';

@Injectable({
    providedIn: 'root'
})
export class IntegrationComissaoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApiIntegration()}/comissao`;
    }

    /** Executa a integração de leitura das comissões com os sistemas ERP's */
    execReadIntegration(entity: IntegrationComissao): Observable<string> {
        // Params
        let params = new HttpParams();
        if (entity) {
            params = entity.createParams(params);
        }

        return this.customHttp.post<string>(this.pathApi, null, {params, responseType: 'text'});
    }

    /** Executa a integração de leitura individual dos dados da comissão informado no ERP */
    execReadIndividualIntegration(id: number): Observable<string> {
        return this.customHttp.post<string>(`${this.pathApi}/individual/${id}`, null, {responseType: 'text'});
    }
}
